import {AudioPlayerItems} from '../types/audio.types';
import radio from 'assets/image/radio-img.png';

export const liveBroadcast: AudioPlayerItems[] = [
    {
        title: 'Прямой эфир',
        url: '',
        tags: [''],
        dateCreate: '',
        parentTitle: '',
        media: {
            audio: {url: 'https://zvezda-radio-rzv.mediacdn.ru/radio/zvezda/zvezda_128', copyright: '', caption: ''},
            images: {
                i16x9: null,
                i16x7: null,
                i4x3: {
                    url: radio.src,
                    caption: '',
                    copyright: '',
                },
            },
        },
        text: 'Прямой эфир',
        anons: 'Слушайте прямо сейчас в прямом эфире...',
    },
];
